import { Button1 } from './assets/button-1'
import { Button2 } from './assets/button-2'
import { Button3 } from './assets/button-3'
import { Button4 } from './assets/button-4'
import { Button5 } from './assets/button-5'

export const defaultTexts = {
  comment: {
    button: 'Enviar',
    placeholder: 'Digite sua resposta aqui:',
  },
  done: {
    title: 'Agradecemos sua resposta',
    description: 'Assim você nos ajuda a tornar o produto cada vez melhor.',
  },
}

export const scores = [
  {
    value: 1,
    Icon: Button1,
    label: 'Extrema insatisfação',
  },
  {
    value: 2,
    Icon: Button2,
    label: 'Insatisfação',
  },
  {
    value: 3,
    Icon: Button3,
    label: 'Neutro',
  },
  {
    value: 4,
    Icon: Button4,
    label: 'Satisfação',
  },
  {
    value: 5,
    Icon: Button5,
    label: 'Extrema satisfação',
  },
]

export const buttonSize = 48

export enum Steps {
  Score = 'score',
  Comment = 'comment',
  Done = 'done',
}
